import { Button, Col, Row, Table } from 'antd';
import ModalMaterial from 'materials/ModalMaterial';
import SpinMaterial from 'materials/SpinMaterial';
import moment from 'moment-timezone';
import React from 'react';

export default function ModalDetailSyncDataComponent(props) {
  const {
    modalDetailSyncData,
    handleCancel,
    detailSyncData,
    isFetchingDetailSyncDataTable,
    detailSyncDataTable = [],
    setCurrentPage,
    totalDatas,
    columnData,
    currentPage,
    handleDownload,
  } = props;

  const formatDate = (dateString, format = 'DD-MM-YYYY HH:mm:ss') => {
    if (!dateString) return '-';

    // console.log(dateString)
    
    const cleanedDate = dateString.endsWith('Z')
      ? dateString.slice(0, -1)
      : dateString;

    // console.log(cleanedDate)

    return moment(cleanedDate).format(format);
  };

  return (
    <ModalMaterial
      width={'70%'}
      teksTitle="DETAIL SYNC DATA API"
      visible={modalDetailSyncData}
      onCancel={() => handleCancel()}
    >
      <SpinMaterial spinning={isFetchingDetailSyncDataTable} size="large">
        <Row style={{ padding: '16px 24px' }} gutter={[0, 24]}>
          <Col span={12}>
            <b>Tanggal Sync Data</b>
            <p>
              {detailSyncData && formatDate(detailSyncData.syncDeliveryDate)}
            </p>
          </Col>
          <Col span={12}>
            <b>Status Pengiriman</b>
            <p>Diterima / Dikembalikan</p>
          </Col>
          <Col span={12}>
            <b>Tanggal Pengiriman</b>
            <p>{detailSyncData && detailSyncData.deliveryDate}</p>
          </Col>
          <Col span={12}>
            <b>Pelanggan</b>
            <p>{detailSyncData && detailSyncData.customer}</p>
          </Col>
          <Col span={12}></Col>
          <Col span={12}>
            <b>Produk</b>
            <p>{detailSyncData && detailSyncData.customerProduct}</p>
          </Col>
        </Row>

        <Table
          style={{ padding: '16px 24px' }}
          rowKey={(record: any) => record.id}
          scroll={{ x: 'auto' }}
          pagination={{
            onChange: page => setCurrentPage(page - 1),

            pageSize: 10,
            total: totalDatas,
            current: currentPage === 0 ? 1 : currentPage + 1,
          }}
          bordered={false}
          dataSource={detailSyncDataTable}
          columns={columnData}
          footer={() => (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                width: '100%',
                gap: 8,
              }}
            >
              <p style={{ margin: 0, fontWeight: 500 }}>
                Total Entri ({totalDatas || 0})
              </p>
            </div>
          )}
        />
        <Row>
          <div
            style={{
              display: 'flex',
              gap: 24,
              justifyContent: 'flex-end',
            }}
          >
            <Button
              type="primary"
              shape="round"
              size="default"
              style={{
                height: '35px',
                width: '100px',
                marginRight: '25px',
                backgroundColor: '#7956EE',
                borderColor: '7956EE',
              }}
              onClick={() => handleDownload()}
            >
              <b>Download</b>
            </Button>
          </div>
        </Row>
      </SpinMaterial>
    </ModalMaterial>
  );
}
